var map = {
	"./green-xmas-poster-image-desktop.jpg": "45ed",
	"./green-xmas-poster-image.jpg": "644f",
	"./green-xmas-video-intro-desktop.mp4": "7711",
	"./green-xmas-video-intro.mp4": "f68e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a938";